<template>
  <div class="plansManage">
    <div style="margin-bottom:20px;">
      <h1 style="text-align:left;">方案管理</h1>
      <el-divider></el-divider>
    </div>
    <div>
      <a href="/write">
        <el-button type="primary" icon="el-icon-plus">添加方案</el-button>
      </a>
    </div>
    <el-table :data="tableData" style="width: 100%" stripe>
      <el-table-column label="id" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="方案" width="180">
        <template slot-scope="scope">{{scope.row.title}}</template>
      </el-table-column>
      <el-table-column label="简介" width="180">
        <template slot-scope="scope">{{scope.row.intro}}</template>
      </el-table-column>
      <el-table-column label="icon" width="180">
        <template slot-scope="scope">{{scope.row.icon}}</template>
      </el-table-column>
      <el-table-column label="发布时间" width="180">
        <template slot-scope="scope">{{scope.row.date}}</template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <a :href="'/admin/UE/'+scope.row.id">
            <el-button size="mini">编辑</el-button>
          </a>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row,tableData)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <v-pagination
      :total="total"
      v-on:prev="prev"
      v-on:next="next"
      v-on:changePage="changePage"
      v-if="total>0"
    ></v-pagination>
  </div>
</template>
<style scoped>
</style>
<script>
export default {
  name: "plansManage",
  data() {
    return {
      total: 0,
      tableData: [
        {
          id: "1",
          date: "2016-05-02",
          intro: "上海市普陀区金沙江路 1518 弄",
          title: "标题",
          content: ""
        }
      ]
    };
  },
  methods: {
    handleDelete(index, row, rows) {
      var self = this;
      this.$confirm("是否删除该系统方案?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.ajax("/plan_id.php?id=" + row.id, "delete", null, function(
            data
          ) {
            rows.splice(index, 1);
            self.total = self.total - 1;
            self.$message({
              message: "删除成功",
              type: "success"
            });
          });
        })
        .catch(() => {});
    },
    prev(page) {
      this.getPlans(page);
    },
    next(page) {
      this.getPlans(page);
    },
    changePage(page) {
      this.getPlans(page);
    },
    getPlans(page) {
      var _this = this;
      $.ajax({
        url: `/plans.php?page=${page}`,
        type: "get",
        data: null,
        success: function(data, textStatus, jqXHR) {
          var data = JSON.parse(data);
          _this.tableData = data.plans;
          _this.total = data.total;
        }
      });
    }
  },
  mounted() {
    var _this = this;
    $.ajax({
      url: "/plans.php?page=1",
      type: "get",
      data: null,
      success: function(data, textStatus, jqXHR) {
        var data = JSON.parse(data);
        _this.tableData = data.plans;
        _this.total = data.total;
      }
    });
  }
};
</script>





// WEBPACK FOOTER //
// src/components/plans_manage.vue